export default __webpack_public_path__ + "assets/dceaf8d84c5ed81fda4eb9c7add69ca7.svg";